import { Injectable } from '@angular/core';

@Injectable()
export class ReleaseNoteContext {

    fileName: string;

}
